module.exports = __webpack_public_path__ + "img/magento-services-integration_small.c519cfb8.jpg";